// import { configureStore } from '@reduxjs/toolkit';
// import systemReducer from './systemInfo';
// import userInfoReducer from './userInfo';

// const store = configureStore({
//   reducer: {
//     system: systemReducer,
//     userInfo: userInfoReducer,
//   },
// });
// export default store;

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userCartReducer from './userCart';
import systemReducer from './systemInfo';
import userInfoReducer from './userInfo';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userInfo'],
};

const rootReducer = combineReducers({
  system: systemReducer,
  userInfo: userInfoReducer,
  userCart: userCartReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
